// Lazy loads the Player component

import { asyncComponent } from 'react-async-component';

const AsyncPlayer = asyncComponent({
	name: 'AsyncPlayer',
	resolve: () => import('./Player')
});

export default AsyncPlayer;



// WEBPACK FOOTER //
// ./src/components/Player/AsyncPlayer.js